import script from "./CompositionFunction.vue?vue&type=script&lang=ts"
export * from "./CompositionFunction.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__